import CachedIcon from '@mui/icons-material/Cached';
import { DocumentIcon,PlusIcon } from "@heroicons/react/24/solid"

const DocumentUploaderForEdit = ({
  title,
  document,
  docRef,
  name,
  onDownload,
  onUpload
}) => {
  const getShortText = (text, max) =>
    text.length > max ? text.substring(0, max) + "..." : text;

  return (
    <div>
      <h4 className="text-slate-600">{title}</h4>
      {document ? (
        <div className="bg-slate-100 rounded-lg p-2 w-56 flex justify-between">
          <div className="flex">
            <div className="text-blue-800 my-auto">
              <DocumentIcon className="w-7 h-7" />
            </div>
            <div
              className="text-blue-500 mx-2 w-fit cursor-pointer"
              onClick={() => onDownload(document)}
            >
              <p className="text-lg">{getShortText(document.name, 15)}</p>
              <p className="text-xs">{getShortText(document.fileName, 19)}</p>
            </div>
          </div>
          <div
            className="h-6 w-6 my-auto cursor-pointer"
            onClick={() => docRef.current.click()}
          >
            <input
              type="file"
              ref={docRef}
              accept=".pdf,.jpg,.jpeg,.png"
              name={name}
              onChange={onUpload}
              className="hidden"
            />
            <CachedIcon style={{ color: "#1e40af" }} />
          </div>
        </div>
      ) : (
        <div
          className="bg-slate-100 rounded-lg p-2 w-20 flex justify-center items-center cursor-pointer"
          onClick={() => docRef.current.click()}
        >
          <input
            type="file"
            ref={docRef}
            accept=".pdf,.jpg,.jpeg,.png"
            name={name}
            onChange={onUpload}
            className="hidden"
          />
          <div className="bg-slate-100 rounded-lg my-auto p-1 text-blue-800 cursor-pointer">
            <PlusIcon className="w-7 h-7" />
          </div>
        </div>
      )}
    </div>
  );
}

export default DocumentUploaderForEdit;